document.addEventListener('DOMContentLoaded', function () {
  const style = new CSSStyleSheet;
  style.replaceSync(`
    ._container_3eyaa_70 {
      display: block;
    }
    ._formFieldContainer_z7chr_5 {
      flex-direction: column-reverse;
      position: initial;
      margin-block: 0;
      justify-content: flex-end;
    }

    ._formFieldContainer_z7chr_5 label,
    ._label_1ujcz_10 {
      position: initial;
      line-height: 1.5;
      color: #000000;
      font-size: 16px;
      font-family: 'Athelas';
      margin-top: 10px;
      margin-bottom: 0;
    }

    ._formFieldContainer_z7chr_5 ._inputFilled_z7chr_69 {
      transform: none;
    }

    ._formFieldContainer_z7chr_5 label:after,
    ._label_1ujcz_10:after {
      content: ':';
      line-height: 1.5;
      color: #000000;
      font-size: 16px;
      font-family: 'Athelas';
    }

    ._formFieldContainer_z7chr_5:focus-within ._formInputFieldLabel_z7chr_37 {
      transform: none;
    }

    div:not(._withError_z7chr_16) input._formInputField_237zm_7,
    div:not(._withError_z7chr_16) ._selectToggle_1ujcz_25 {
      padding: 7px 15px;
      border-radius: 0;
      border: 1px solid #B6B5B5;
      height: 60px;
      margin-bottom: 3px;
      box-sizing: border-box;
      box-shadow: none;
      max-height: none;
    }

    div:not(._withError_z7chr_16) ._textArea_17mgw_1 {
      padding: 7px 15px !important;
      border-radius: 0;
      border: 1px solid #B6B5B5;
      margin-bottom: 3px;
      box-sizing: border-box;
      box-shadow: none;
    }

    div._withError_z7chr_16 input._formInputField_237zm_7,
    div._withError_z7chr_16 ._selectToggle_1ujcz_25,
    div._withError_z7chr_16 ._textArea_17mgw_1 {
      margin-bottom: 3px;
    }

    ._error_1o4ef_1 {
      margin-top: 3px;
    }

    div._withError_z7chr_16 > input,
    ._invalid_17mgw_14 {
      box-shadow: 0 0 0 1px var(--form-error-color) !important;
    }

    ._inline_whyqz_45 ._formContainer_whyqz_30 {
      min-width: auto;
      max-width: none;
    }

    form._formFieldset_16kdc_67 {
      padding-bottom: 20px;
      gap: 0 10px;
      position: relative;
      display: grid;
      grid-template-columns: repeat(2, minmax(100px, 1fr)) minmax(30px, 100px) repeat(2, minmax(100px, 1fr));
      grid-template-rows: minmax(20px, 1fr);
      grid-template-areas:
        'title01 title01 title01 title01 title01'
        'legal_name legal_name . duns yr_business'
        'error__legal_name error__legal_name . error__duns error__yr_business'

        'email_company email_company . how_long_location how_long_location'
        'error__email_company error__email_company . error__how_long_location error__how_long_location'

        'business_phone business_phone . address_company address_company'
        'error__business_phone error__business_phone . error__address_company error__address_company'

        'type_of other_federal . city_company city_company'
        'error__type_of error__other_federal . error__city_company error__city_company'
        
        'dba ein . state_company zip_company'
        'error__dba error__ein . error__state_company error__zip_company'

        'address_shipping_company address_shipping_company . zip_shipping_company .'
        'error__address_shipping_company error__address_shipping_company . error__zip_shipping_company .'

        '. button01 button01 button01 .'


        'title02 title02 title02 title02 title02'
        'owner_name owner_name . owner_address owner_address'
        'error__owner_name error__owner_name . error__owner_address error__owner_address'

        'owner_email owner_email . owner_city owner_city'
        'error__owner_email error__owner_email . error__owner_city error__owner_city'

        'owner_phone owner_phone . owner_state owner_zip'
        'error__owner_phone error__owner_phone . error__owner_state error__owner_zip'

        '. button02-1 . button02-2 .'


        'title03 title03 title03 title03 title03'
        'credit_company credit_company . credit_address credit_address'
        'error__credit_company error__credit_company . error__credit_address error__credit_address'

        'credit_phone credit_phone . credit_city credit_city'
        'error__credit_phone error__credit_phone . error__credit_city error__credit_city'

        'credit_email credit_email . credit_state credit_zip'
        'error__credit_email error__credit_email . error__credit_state error__credit_zip'

        '. button03-1 . button03-2 .'
      ;
    }

    @media screen and (max-width: 1024px) {
      form._formFieldset_16kdc_67 {
        grid-template-columns: repeat(2, minmax(100px, 1fr)) 30px repeat(2, minmax(100px, 1fr));
      }
    }

    @media screen and (max-width: 749px) {
      form._formFieldset_16kdc_67 {
        grid-template-areas:
        'title01 title01 title01 title01 title01'
        'legal_name legal_name . duns duns'
        'error__legal_name error__legal_name . error__duns error__duns'

        'email_company email_company . yr_business yr_business'
        'error__email_company error__email_company . error__yr_business error__yr_business'
        
        'business_phone business_phone . how_long_location how_long_location'
        'error__business_phone error__business_phone . error__how_long_location error__how_long_location'

        'type_of type_of . address_company address_company'
        'error__type_of error__type_of . error__address_company error__address_company'

        'other_federal other_federal . city_company city_company'
        'error__other_federal error__other_federal . error__city_company error__city_company'

        'dba dba . state_company state_company'
        'error__dba error__dba . error__state_company error__state_company'

        'ein ein . zip_company zip_company'
        'error__ein error__ein . error__zip_company error__zip_company'

        'address_shipping_company address_shipping_company . zip_shipping_company zip_shipping_company'
        'error__address_shipping_company error__address_shipping_company . error__zip_shipping_company error__zip_shipping_company'
        '. button01 button01 button01 .'


        'title02 title02 title02 title02 title02'
        'owner_name owner_name . owner_address owner_address'
        'error__owner_name error__owner_name . error__owner_address error__owner_address'

        'owner_email owner_email . owner_city owner_city'
        'error__owner_email error__owner_email . error__owner_city error__owner_city'

        'owner_phone owner_phone . owner_state owner_state'
        'error__owner_phone error__owner_phone . error__owner_state error__owner_state'

        'owner_zip owner_zip . . .'
        'error__owner_zip error__owner_zip . . .'
        '. button02-1 . button02-2 .'


        'title03 title03 title03 title03 title03'
        'credit_company credit_company . credit_address credit_address'
        'error__credit_company error__credit_company . error__credit_address error__credit_address'

        'credit_phone credit_phone . credit_city credit_city'
        'error__credit_phone error__credit_phone . error__credit_city error__credit_city'

        'credit_email credit_email . credit_state credit_state'
        'error__credit_email error__credit_email . error__credit_state error__credit_state'

        'credit_zip credit_zip . . .'
        'error__credit_zip error__credit_zip . . .'
        '. button03-1 . button03-2 .'
      ;
      }
    }

    @media screen and (max-width: 500px) {
      form._formFieldset_16kdc_67 {
        grid-template-columns: 1fr;
        grid-template-areas:
        'title01'
        'legal_name'
        'error__legal_name'

        'email_company'
        'error__email_company'

        'business_phone'
        'error__business_phone'

        'type_of'
        'error__type_of'

        'other_federal'
        'error__other_federal'

        'dba'
        'error__dba'

        'ein'
        'error__ein'

        'duns'
        'error__duns'

        'yr_business'
        'error__yr_business'

        'how_long_location'
        'error__how_long_location'

        'address_company'
        'error__address_company'

        'city_company'
        'error__city_company'

        'state_company'
        'error__state_company'

        'zip_company'
        'error__zip_company'

        'address_shipping_company'
        'error__address_shipping_company'

        'zip_shipping_company'
        'error__zip_shipping_company'
        'button01'


        'title02'
        'owner_name'
        'error__owner_name'

        'owner_email'
        'error__owner_email'

        'owner_phone'
        'error__owner_phone'

        'owner_address'
        'error__owner_address'

        'owner_city'
        'error__owner_city'

        'owner_state'
        'error__owner_state'

        'owner_zip'
        'error__owner_zip'

        'button02-1' 
        'button02-2'


        'title03'
        'credit_company'
        'error__credit_company'

        'credit_phone'
        'error__credit_phone'

        'credit_email'
        'error__credit_email'

        'credit_address'
        'error__credit_address'

        'credit_city'
        'error__credit_city'

        'credit_state'
        'error__credit_state'

        'credit_zip'
        'error__credit_zip'

        'button03-1'
        'button03-2'
      ;
      }
    }

    .pagination-container {
      display: flex;
      gap: 47px;
      justify-content: center;
      margin-bottom: 30px;
    }

    .pagination-title {
      width: 48px;
      height: 48px;
      background: #E5E5E5;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'Lato'; 
      font-size: 16px;
      position: relative;
    }

    .title-page[data-page-content="1"] .title-01,
    .title-page[data-page-content="2"] .title-02,
    .title-page[data-page-content="3"] .title-03 {
      animation-fill-mode: forwards;
      animation-name: comDestaque;
      animation-duration: 0.5s;
    }

    @keyframes comDestaque {
      from {
        background: #E5E5E5;
        color: #000000;
      }
      to {
        background: #000000;
        color: #ffffff;
      }
    }

    .pagination-title:nth-child(2):before,
    .pagination-title:nth-child(2):after {
      content: '';
      width: 32px;
      height: 6px;
      background: url('data:image/svg+xml,<svg width="32" height="7" viewBox="0 0 32 7" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="3.66643" cy="3.76714" r="2.91057" fill="%23C8C8C8"/><circle cx="12.141" cy="3.76726" r="2.91057" fill="%23C8C8C8"/><circle cx="20.6147" cy="3.76726" r="2.91057" fill="%23C8C8C8"/><circle cx="29.0893" cy="3.76726" r="2.91057" fill="%23C8C8C8"/></svg>') no-repeat center;
      position: absolute;
    }

    .pagination-title:nth-child(2):before {
      left: 0;
      transform: translateX(-100%);
      padding-right: 13px;
    }

    .pagination-title:nth-child(2):after {
      right: 0;
      transform: translateX(100%);
      padding-left: 13px;
    }

    .title-page {
      font-size: 20px;
      text-transform: uppercase;
      font-family: 'Athelas';
      letter-spacing: 1px;
      margin: 20px 0;
      text-align: center;
    }

    button._formSubmitButton_16kdc_81 {
      margin-top: 50px;
      max-width: 200px;
      justify-self: center;
      width: 100%;
      font-family: 'Athelas';
      font-size: 16px;
      text-transform: uppercase;
      letter-spacing: 1px;
      border-radius: 50px;
      transition: .3s;
    }

    button._formSubmitButton_16kdc_81:hover {
      filter: none;
      box-shadow: 0 0 0 2px #000000;
    }

    .button-form {
      display: flex;
      justify-content: center;
      line-height: var(--forms-base-font-line-height);
      padding: var(--button-padding);
      background-color: var(--button-background-color);
      color: #FFFFFF;
      border: none;
      box-shadow: none;
      outline: var(--button-border);
      outline-offset: 1px;
      border-radius: 50px;
      cursor: pointer;
      max-width: 200px;
      width: 100%;
      justify-self: center;
      margin-top: 50px;
      font-family: 'Athelas';
      font-size: 16px;
      text-transform: uppercase;
      letter-spacing: 1px;
      transition: .3s;
    }

    .button-form:hover {
      box-shadow: 0 0 0 2px #000000;
    }

    .button-form[data-type="previous"] {
      background: #808080;
    }

    .button-form[data-type="previous"]:hover {
      box-shadow: 0 0 0 2px #808080;
    }

    ._formBannerHeading_1t76a_9 {
      font-size: 24px !important;
      font-family: 'Athelas' !important;
      text-transform: uppercase;
      margin-bottom: 20px !important;
      font-weight: 400! important;
    }

    ._textBody_2aowh_10 p {
      font-family: 'Athelas';
      font-size: 16px;
      line-height: 2;
      color: rgba(var(--color-foreground), 0.75);
    }

    .hidden {
      display: none !important;
    }
  `)

  const interval = setInterval(() => {
    const getFormContainer = document.querySelector('.app-page--register .shopify-app-block > div > *')

    if (getFormContainer) { 
      clearInterval(interval)
      const getFormShadow = getFormContainer.shadowRoot;

      const form = Array.from(getFormShadow.querySelectorAll('._formFieldset_16kdc_67 > *'))

      const createPagination = (indexPage) => {
        const paginationContainer = document.createElement('div')
        paginationContainer.classList.add('pagination-container')
        paginationContainer.dataset.pageContent = indexPage

        for (let i = 1; i <= 3; i++) {
          const page = document.createElement('div')
          page.textContent = `${i}`
          page.classList.add('pagination-title', `title-0${i}`)
          paginationContainer.appendChild(page)
        }
        return paginationContainer
      }

      const createNewDivTitle = (textTitlePage, indexPage, divItem) => {
        const divTitlePage = document.createElement('div')
        const newText = document.createElement('p')
        newText.textContent = textTitlePage
        const classHidden = indexPage !== 1 ? 'hidden' : 'not-hidden'

        divTitlePage.classList.add('title-page', classHidden)
        divTitlePage.dataset.pageContent = indexPage
        divTitlePage.appendChild(createPagination(indexPage))
        divTitlePage.appendChild(newText)

        divItem.parentNode.insertBefore(divTitlePage, divItem);
      }

      const createButton = (indexPage, divItem, type) => {
        const button = document.createElement('div')
        const classHidden = indexPage !== 1 ? 'hidden' : 'not-hidden'
        
        button.dataset.pageContent = indexPage;
        button.dataset.type = type;
        button.textContent = type === 'next' ? 'Continue' : 'Return'

        button.classList.add('button-form', `form-page-0${indexPage}`, classHidden)
        divItem.insertAdjacentElement('afterend', button)
      }

      const arrayGridAreas = [
        'title01', 'legal_name', 'email_company', 'business_phone', 'type_of', 'other_federal', 'dba', 'ein', 'duns', 'yr_business', 'how_long_location', 'address_company', 'city_company', 'state_company', 'zip_company', 'address_shipping_company', 'zip_shipping_company', 'button01',

        'title02', 'owner_name', 'owner_email', 'owner_phone', 'owner_address', 'owner_city', 'owner_state', 'owner_zip', 'button02-1', 'button02-2',

        'title03', 'credit_company', 'credit_phone', 'credit_email', 'credit_address', 'credit_city', 'credit_state', 'credit_zip', 'button03-1', 'button03-2'
      ]

      let initPage01 = 0
      let finalPage01 = 15
      let initPage02 = 16
      let finalPage02 = 22
      let initPage03 = 23

      form.map((item, index) => {
        if (index >= initPage01 && index <= finalPage01) {
          item.dataset.pageContent = 1
          if (index === initPage01) createNewDivTitle('Company information', 1, item)
          if (index === finalPage01) createButton(1, item, 'next')
          
        } else if (index >= initPage02 && index <= finalPage02) {
          item.classList.add('hidden')
          item.dataset.pageContent = 2
          if (index === initPage02) createNewDivTitle('owner information (required for processing)', 2, item)
          if (index === finalPage02) {
            createButton(2, item, 'next')
            createButton(2, item, 'previous')
          }

        } else {
          item.classList.add('hidden')
          item.dataset.pageContent = 3
          if (index === initPage03) createNewDivTitle('credit references (optional)', 3, item)
          if (index === form.length - 2) createButton(3, item, 'previous')
          
        }
      })

      const newForm = Array.from(getFormShadow.querySelectorAll('._formFieldset_16kdc_67 > *'))
      newForm.map((item, index) => item.style.gridArea = arrayGridAreas[index])

      const allButtons = Array.from(getFormShadow.querySelectorAll('.button-form'))

      allButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const newForm = Array.from(getFormShadow.querySelectorAll('._formFieldset_16kdc_67 > *'))
          const pageContent = Number(button.dataset.pageContent)

          if (button.dataset.type === 'next') {
            newForm.map((item) => {
              const itemDataSet = Number(item.dataset.pageContent)
              if (itemDataSet === pageContent) item.classList.add('hidden')
              else if (itemDataSet === pageContent + 1) item.classList.remove('hidden')
            })

          } else {
            newForm.map((item) => {
              const itemDataSet = Number(item.dataset.pageContent)
              if (itemDataSet === pageContent) item.classList.add('hidden')
              else if (itemDataSet === pageContent - 1) item.classList.remove('hidden')
            })
          }

          window.scrollTo({ top: 0, behavior: 'smooth' });
        })
      })

      const verifyErrors = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        const internalVerifyErros = setInterval(() => {
          const allErrors = Array.from(getFormShadow.querySelectorAll('._formError_z7chr_20'))
  
          if (allErrors.length > 0) {
            clearInterval(internalVerifyErros)

            const formWithErrors = Array.from(getFormShadow.querySelectorAll('._formFieldset_16kdc_67 > *'))

            allErrors.forEach((error) => {
              const divParam = error.previousElementSibling
              const getStyle = window.getComputedStyle(divParam)
              const getGridArea = getStyle.gridArea
              
              error.dataset.pageContent = divParam.getAttribute('data-page-content')
              error.style.gridArea = `error__${getGridArea}`

              formWithErrors.forEach((item) => {
                if (item.dataset.pageContent !== '1') item.classList.add('hidden')
                else item.classList.remove('hidden')
              } )
            })
          }
        }, 100)
      }

      const regiterButton = getFormShadow.querySelector('._formSubmitButton_16kdc_81')
      regiterButton.addEventListener('click', () => verifyErrors())

      getFormContainer.shadowRoot.adoptedStyleSheets.push(style)
    }
  }, 500)
})
